import * as React from 'react';
import { Theme } from '@material-ui/core/styles';
import withStyles, { WithStyles, StyleRules, ClassNameMap } from '@material-ui/core/styles/withStyles';
import {Button} from '@material-ui/core';
import { Typography } from '@material-ui/core';
import {Dialog, DialogTitle, DialogContent, DialogActions, FormControl, InputLabel, Select, MenuItem, FormHelperText} from '@material-ui/core';
import {Grid} from '@material-ui/core';
import { APIError } from '~common/lib/types';
import * as request from 'superagent';

interface Props extends React.HTMLProps<HTMLDivElement> {
    classes: any;
    open: boolean;
    proxyOptions: Array<any>;
    handleClose: ()=>void
}

type State = {
    open: boolean;
    selectedProxy?: any;
    error?: APIError;
};

const styles = (theme:Theme):StyleRules => ({
    modalContent: {
        width: 500
    },
    actionAutoConfirmButtonClass:{
        border: 'dashed 1px #dedede'
    },
    modalTitle: {
        padding: "0px 0px 20px 0px"
    },
    gridItem: {
        paddingBottom: "0px !important;",
        paddingTop: "0px !important;"
    },
    controlContainer: {
        width: "100%",
        padding: 0
    },
    dangerButton: {
        backgroundColor: "#af0202",
        '&:hover': {
            backgroundColor: "#5D0A0A !important"
        }
    },
    proxySelect: {
        width: "100%"
    }
})

class ConfirmCancelModal extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
    constructor(props: Props) {
        super(props, {});
        this.state = {
            open: true
        }
      }
    

    handleClose = () => {
        this.props.handleClose()
     }
     
     startProxy = () => {
         if (this.state.selectedProxy) {
            request.post(`/api/portal-user-proxy/${this.state.selectedProxy.portalUserID}/start`).then((response: request.Response)=>{
                if (!response.ok) {
                    const apiErr = new APIError()
                    apiErr.type = "api"
                    apiErr.message = "Error Saving Proxies"
                    apiErr.details = response.body.toString()
                    this.setState({
                        error: apiErr
                    })
                } else {
                    console.log("proxy response", response.body)
                    window.location.href = "/"
                }
            }).catch((err)=>{
                console.error(err)
                const apiErr = new APIError()
                apiErr.type = "http"
                apiErr.message = "Error fetching data"
                apiErr.details = (err.response || {text: err.toString()}).text
                this.setState({
                    error: apiErr
                })
            })
         }
     }

     onSelectChange = (event: any) => {
        console.log("onSelectChange", event.target.value)
        var proxy = this.props.proxyOptions.find((p: any)=>{
            return p.portalUserID == event.target.value
        })
        if (proxy) {
            this.setState({
                selectedProxy: proxy
            })
        }
     }

    render() {
        const { classes }: { classes: ClassNameMap;} = this.props;
        const {open} = this.state
        const {proxyOptions} = this.props

        return (
            <Dialog
                className={classes.modal}
                open={open}
                onClose={this.handleClose}
                disableBackdropClick={true}
            >   
                <DialogContent className={classes.modalContent}>
                    <DialogTitle className={classes.modalTitle}>
                        Select Proxy
                    </DialogTitle>  
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Typography variant="subtitle1">Select a user you would like to proxy.</Typography> 
                        </Grid>
                        
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <FormControl className={classes.proxySelect}>
                                <InputLabel shrink={true} required={true}>Proxy As User</InputLabel>
                                <Select
                                    className={classes.proxySelect}
                                    value={this.state.selectedProxy ? this.state.selectedProxy.portalUserID : ""}
                                    onChange={this.onSelectChange}
                                    classes={{}}
                                    error={false}
                                    disabled={this.props.disabled}
                                >
                                {proxyOptions.map((p: any, idx)=>{
                                    return (
                                        <MenuItem key={idx} value={p.portalUserID}>{p.userFullName}</MenuItem>
                                    )
                                })}
                                </Select>
                                <FormHelperText>{}</FormHelperText>
                            </FormControl> 
                        </Grid>
                       
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button 
                        variant="contained"
                        color="default"
                        onClick={this.handleClose}>
                        Cancel
                    </Button>
                    <Button 
                        autoFocus={true}
                        variant="contained"
                        color="secondary"
                        className={classes.actionAutoConfirmButtonClass} 
                        disabled={this.state.selectedProxy ? false : true} 
                        onClick={this.startProxy}>
                        Start
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(styles)(ConfirmCancelModal);